import React, { useEffect, useState } from 'react';
import styles from "./Step1.module.scss";
import Sectors from "../Sectors/Sectors";
import { Tooltip } from 'react-tooltip';
import { VscChromeClose, VscLockSmall } from "react-icons/vsc";
import Utilities from "../utils/Utilities.js";

function Step1_2(props) {
  let items = props.selectedServices;
  const [hideTooltip, setHideTooltip] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setHideTooltip(true);
    });
    
    // Detect scroll end using a debouncing technique
    let scrollTimeout;
    
    window.addEventListener('scroll', () => {
      // Clear the previous timeout to debounce the scroll event
      clearTimeout(scrollTimeout);
    
      // Set a new timeout
      scrollTimeout = setTimeout(() => {
        // This function will be called after scrolling stops
        setHideTooltip(false);
      }, 250); // Adjust this timeout value as needed
    });
  }, [])

  const handleDeSelectButtonClick = (onServiceDeSelect, item) => {
    if (onServiceDeSelect) {
      onServiceDeSelect(item);
    }
  };

  return (
    <div>
      <span className={styles["step-title"]}>
        Servizi consigliati
      </span>
      <p className={styles["step-description"]}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, met, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam
      </p>
      <Sectors
        data={props.data}
        selectedServices={props.selectedServices}
        onServiceSelect={props.onServiceSelect}
        onServiceDeSelect={props.onServiceDeSelect}
        onSearch={props.onSearch}
        currentStep={props.currentStep}
        />
      {!props.isMobile && (
          <div className={styles["cart-container"]} > 
            <div className={styles["cart-inner-container"]}>
                <div className={styles["cart-services-container"]} >
                {items && ( items.map((item, index)=>{
                        return(
                            <>
                              {item.selectionMode === Utilities.MANUAL && (
                                <div className={styles["cart-item"]}>
                                  <span className={styles["cart-item-name"]}>{item.name[0].toUpperCase() + item.name.slice(1).toLowerCase()}</span>
                                  <VscChromeClose
                                    size="12"
                                    className={styles["cart-item-close-icon"]}
                                    onClick={() => handleDeSelectButtonClick(props.onServiceDeSelect, item)}
                                  />
                                </div>
                              )}
                        
                              {item.selectionMode === Utilities.INCLUDED && (
                                <>
                                  <div className={styles["cart-item-included"]}
                                    data-tooltip-id="info-icon-tooltip"
                                    data-tooltip-hidden={hideTooltip}
                                    data-tooltip-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                    data-tooltip-place="top-end"
                                  >
                                    <span className={styles["cart-item-name"]}>{item.name[0].toUpperCase() + item.name.slice(1).toLowerCase()}</span>
                                    <VscLockSmall size="15" className={styles["cart-item-lock-icon"]} />
                                  </div>
                                  <Tooltip
                                    id="info-icon-tooltip"
                                    className={styles["infoTooltip"]}
                                    place="top-end"
                                    type="light"
                                    style={{
                                      width: "264px",
                                      backgroundColor: "white",
                                      boxShadow: "-0px -0px 10px #2222221A",
                                      color: "#222",
                                      opacity: "1",
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      lineHeight: "19px",
                                      letterSpacing: "0em",
                                      textAlign: "left",
                                    }}
                                  />
                                </>
                              )}
                            </>
                        )})) 
                      }
                </div>
                <button
                    className={styles["cart-book-button"]}
                    isselected="no"
                    onClick={props.onBook}
                >
                    {items.length > 0 ? 'CONTINUA' : 'CONTINUA SENZA AGGIUNGERE'}
                </button>
        
            </div>
          </div>
      )}
    </div>
  );
}

export default Step1_2;